'use strict';

/**
* @ngdoc directive
* @name tcApp.directive:tcCustomTemplateItem
* @element ANY
* @description
* Directive for custom template component items that provides similar functionality to ngInit.
* Initialises 'dataItem' and 'customItem' variables on a child scope, and watches the expression for changes
*/
angular.module('tcApp')
.directive('tcCustomTemplateItem', function() {
	return {
		priority: 450,
		restrict: 'A',
		scope: true,
		compile: function() {
			return {
				pre: function(scope, element, attrs) {
					var watchChangesUnbind;
					scope.dataItem = scope.$eval(attrs.tcCustomTemplateItem);
					scope.customItem = (angular.isDefined(scope.dataItem) ? scope.dataItem.value : undefined);

					scope.$watch(attrs.tcCustomTemplateItem, function(dataItem) {
						scope.dataItem = dataItem;
						scope.customItem = (angular.isDefined(dataItem) ? dataItem.value : undefined);
						
						if ((angular.isFunction(watchChangesUnbind))
							&& (angular.isDefined(dataItem)) && (angular.isDefined(dataItem.value))
							&& ((angular.isUndefined(dataItem.value._watchChanges))
								|| (angular.fromJson(dataItem.value._watchChanges) !== true))) {
							watchChangesUnbind();
						}
					});
					
					// Allow to replace the custom item value in the component script by watching the value for changes
					// Note that this can impact performance, so should only be used where necessary
					if ((angular.isDefined(scope.dataItem)) && (angular.isDefined(scope.dataItem.value))
						&& (angular.fromJson(scope.dataItem.value._watchChanges) === true)) {
						watchChangesUnbind = scope.$watch((attrs.tcCustomTemplateItem + '.value'), function(newValue) {
							scope.customItem = newValue;
						}, true);
					}
				}
			};
		}
		
	};
});
